import { render } from "./Agents-page.vue?vue&type=template&id=200e1c28&scoped=true"
import script from "./Agents-page.vue?vue&type=script&lang=js"
export * from "./Agents-page.vue?vue&type=script&lang=js"

import "./Agents-page.vue?vue&type=style&index=0&id=200e1c28&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200e1c28"]])

export default __exports__